<template>
    <div class="links">
        <div class="links-header">
            <div>{{linksHeader}}</div>
            <dx-button width="26"
                       height="26"
                       type="normal"
                       class="ml-2"
                       styling-mode="contained"
                       @click="isAddFormVisible = true">
                <i class="fas fa-plus"></i>
            </dx-button>
        </div>
        <div class="links-form" v-show="isAddFormVisible">
            <dx-validation-group :ref="`addValidationGroup`">
                <div>
                    <dx-text-box v-model="addForm.linkName"
                                 class="mb-1"
                                 :placeholder="$t('links.placeholders.pageName')">
                        <dx-validator>
                            <dx-required-rule :message="$t('fieldRules.reuiredShort')" />
                        </dx-validator>
                    </dx-text-box>
                    <dx-text-box v-model="addForm.linkUrl"
                                 class="mb-1"
                                 :placeholder="$t('links.placeholders.link')">
                        <dx-validator>
                            <dx-required-rule :message="$t('fieldRules.reuiredShort')" />
                        </dx-validator>
                    </dx-text-box>
                </div>
                <div class="">
                    <dx-button :text="$t('buttons.cancel')" type="normal" styling-mode="outlined" @click="isAddFormVisible = false, resetAddForm()" />
                    <dx-button :text="$t('buttons.save')" type="default" class="ml-1" @click="addLinkHandler" />
                </div>
            </dx-validation-group>
        </div>
        <div class="links-list">
            <dx-list :items="linksList"
                      key-expr="Id">
                <template #item="{ data: item }">
                    <div class="link-list-el">
                        <span  @click="redirectTo(item.Url)">{{item.Name}}</span>
                        <div class="link-list-el-actions">
                            <span v-if="isEditMode" :title="$t('buttons.edit')" @click="showEditPopupHandler(item)"><i class="fas fa-pen"></i></span>
                            <span v-if="isEditMode" :title="$t('buttons.delete')" class="ml-1" @click="showDeletePopupHandler(item)"><i class="fas fa-trash"></i></span>
                        </div>
                    </div>
                </template>
                <dx-item-dragging :data="linksList"
                                  :allow-reordering="isListReorderingAllowed"
                                  :on-reorder="onListReorder">
                </dx-item-dragging>
            </dx-list>
        </div>
        <ul class="links-actions">
            <li @click="editListSwitch()" class="mb-1">
                <span v-if="!isEditMode">
                    <i class="fas fa-pen"></i>
                    {{ $t('links.edit') }}
                </span>
                <span class="is-active" v-else>
                    <i class="fas fa-check"></i>
                    {{ $t('links.completeEditing') }}
                </span>
            </li>
            <!--<li @click="editListOrderSwitch()" class="mb-1">
                <span v-if="!isEditOrderMode">
                    <i class="fas fa-arrows-alt"></i>
                    {{ $t('links.reorder') }}
                </span>
                <span class="is-active" v-else>
                    <i class="fas fa-check"></i>
                    {{ $t('links.complete') }}
                </span>
            </li>-->
        </ul>

        <!-- Edit popup -->
        <rd-popup :visibility="isEditPopupVisible" :title="$t('details.label.editLink')" :show-hide-button="false">
            <form @submit.prevent="editForm">
                <dx-validation-group :ref="`editValidationGroup`">
                    <rd-popup-content>
                        <div class="row">
                            <rd-column :size="$columns.SixOnLg">
                                <rd-form-group :label="$t('links.placeholders.pageName')">
                                    <dx-text-box v-model="editForm.linkName">
                                        <dx-validator>
                                            <dx-required-rule :message="$t('fieldRules.reuiredShort')" />
                                        </dx-validator>
                                    </dx-text-box>
                                </rd-form-group>
                            </rd-column>
                            <rd-column :size="$columns.SixOnLg">
                                <rd-form-group :label="$t('links.placeholders.link')">
                                    <dx-text-box v-model="editForm.linkUrl">
                                        <dx-validator>
                                            <dx-required-rule :message="$t('fieldRules.reuiredShort')" />
                                        </dx-validator>
                                    </dx-text-box>
                                </rd-form-group>
                            </rd-column>
                        </div>
                    </rd-popup-content>
                    <rd-popup-actions>
                        <dx-button :use-submit-behavior="false"
                                   type="normal"
                                   :text="$t('buttons.cancel')"
                                   @click="isEditPopupVisible = false">
                        </dx-button>
                        <dx-button :use-submit-behavior="false"
                                   type="default"
                                   class="ml-1"
                                   @click="editLinkHandler"
                                   :text="$t('buttons.save')"></dx-button>
                    </rd-popup-actions>
                </dx-validation-group>
            </form>
        </rd-popup>

        <!-- Delete popup -->
        <rd-popup :visibility="isDeletePopupVisible" :title="$t('details.label.deleteLink')" :show-hide-button="false">
            <rd-popup-content>
                <div class="row">
                    <rd-column :size="$columns.TwelveOnLg">
                        <h4> {{ $t('links.popup.removeconfirmationMsg')}} {{deleteForm.linkName}}?</h4>
                    </rd-column>
                </div>
            </rd-popup-content>
            <rd-popup-actions>
                <dx-button :use-submit-behavior="false"
                            type="normal"
                            :text="$t('buttons.cancel')"
                            @click="isDeletePopupVisible = false">
                </dx-button>
                <dx-button :use-submit-behavior="false"
                            type="danger"
                            class="ml-1"
                            @click="deleteLinkHandler"
                            :text="$t('buttons.save')"></dx-button>
            </rd-popup-actions>
        </rd-popup>
    </div>
</template>
<script>
    import DxList, { DxItemDragging } from 'devextreme-vue/list';
    import DxButton from 'devextreme-vue/button';
    import DxTextBox from 'devextreme-vue/text-box';
    import { DxRequiredRule, DxValidator } from 'devextreme-vue/validator';
    import DxValidationGroup from 'devextreme-vue/validation-group';

    import commonMessages from "../../../locales";
    import localMessages from "../../locales";

   import { v4 as uuidv4 } from 'uuid';

    export default {
        name: "links",
        props: ["linksList", "linksHeader"],
        data() {
            return {
                isAddFormVisible: false,
                isEditPopupVisible: false,
                isDeletePopupVisible: false,
                addForm: {
                    linkName: '',
                    linkUrl: null,
                },
                editForm: {
                    id: null,
                    linkName: '',
                    linkUrl: null,
                },
                deleteForm: {
                    id: null,
                    linkName: '',
                },
                isEditMode: false,
                //isEditOrderMode: false,
                isListReorderingAllowed: false,
                reorderedList: []
            };
        },
        methods: {
            redirectTo: function (e) {
                let url = e.match(/^https?:/) ? e : '//' + e;
                let win = window.open(url, '_blank');
                win.focus();
            },
            addLinkHandler: function () {
                let validateResult = this.$refs["addValidationGroup"].instance.validate();
                if (validateResult.isValid) {
                    let payload = {
                        Id: uuidv4(),
                        Name: this.addForm.linkName,
                        Url: this.addForm.linkUrl
                    }
                    this.$emit("addLink", payload);
                    this.isAddFormVisible = false;
                    this.resetAddForm();
                }
            },
            editLinkHandler: function () {
                let validateResult = this.$refs["editValidationGroup"].instance.validate();
                if (validateResult.isValid) {
                    let payload = {
                        Id: this.editForm.id,
                        Name: this.editForm.linkName,
                        Url: this.editForm.linkUrl
                    }
                    this.$emit("editLink", payload);
                    this.isEditPopupVisible = false;
                }
            },
            deleteLinkHandler: function () {
                let payload = {
                    itemId: this.deleteForm.id,
                }
                this.$emit("deleteLink", payload);
                this.isDeletePopupVisible = false;

            },
            resetAddForm: function () {
                this.addForm.linkName = '';
                this.addForm.linkUrl = null;
            },
            editListSwitch: function () {
                this.isEditMode = !this.isEditMode;
                this.isListReorderingAllowed = !this.isListReorderingAllowed;
            },
            //editListOrderSwitch: function () {
            //    debugger;
            //    this.isListReorderingAllowed = !this.isListReorderingAllowed;
            //    this.isEditOrderMode = !this.isEditOrderMode;
            //},
            showEditPopupHandler: function (e) {
                this.isEditPopupVisible = true;
                this.editForm.id = e.Id
                this.editForm.linkName = e.Name;
                this.editForm.linkUrl = e.Url;
            },
            showDeletePopupHandler: function (e) {
                this.isDeletePopupVisible = true;
                this.deleteForm.id = e.Id
                this.deleteForm.linkName = e.Name;
            },
            onListReorder: function (e) {
                const list = this.linksList.splice(e.fromIndex, 1)[0];
                this.linksList.splice(e.toIndex, 0, list);

                this.$emit("listReorder", e.toData);
            },
        },
        components: {
            DxList,
            DxItemDragging,
            DxValidator,
            DxButton,
            DxTextBox,
            DxRequiredRule,
            DxValidationGroup
        },
        i18n: {
            messages: localMessages.messages,
            sharedMessages: commonMessages.messages
        }
    };
</script>
